// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner-module--root--1Ho-z","visible":"Banner-module--visible--1Dul2","hidden":"Banner-module--hidden--Pz4XI"};